import { DaoService } from './../servicos/dao.service';
import { Component, OnInit } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-faleconosco',
  templateUrl: './faleconosco.component.html',
  styleUrls: ['./faleconosco.component.css']
})
export class FaleconoscoComponent implements OnInit {

  constructor(private dao: DaoService, private loader: NgxUiLoaderService, public formBuilder: FormBuilder, public messageService: MessageService) { }

  email: any;
  localizacao:any;

  ngOnInit() {
    this.carregarFormularios();
    this.processarLocalizacao();
  }

  async processarLocalizacao(){
    let r = await fetch('https://diviprev.mg.gov.br/controladores/ip.php');
    if(r && r.ok){
      r = await r.json();
      console.log("Ip -- ",r);
      this.localizacao = r;
    }
  }

  enviarToast(cor, titulo, texto) {
    this.messageService.add({ severity: cor, summary: titulo, detail: texto });
  }

  categorias: any = [
    { label: 'Selecione a Categoria', value: null },
     { label: 'Sugestão', value: 'sugestao' },
      { label: 'Reclamação', value: 'reclamacao' },
      { label: 'Elogio', value: 'elogio' },
      { label: 'Solicitação', value: 'solicitacao' },
       { label: 'Informação', value: 'informacao' }];

  formulario: FormGroup;

  carregarFormularios() {
    this.formulario = this.formBuilder.group({

      email: [null, Validators.required],
      nome: [null, Validators.required],
      telefone: [null, Validators.required],
      mensagem: [null, Validators.required],
      categoria: [null, Validators.required]
    })
  }

  verificaValidTouched(campo) {
    return !this.formulario.get(campo).valid && this.formulario.get(campo).touched;
  }

  salvarMomento(){
    let agora = Date.now();
    let tempo = {momento:agora};
    localStorage.setItem('momento',JSON.stringify(tempo));
  }

  verificarTempo(){
    let antes = localStorage.getItem('momento');
    if(antes){
      let an = JSON.parse(antes)['momento'];
      let duracao = Date.now() - an;
      console.log("Duracao:",duracao);
      if(duracao>600000){
        return true;
      }else{
        return false;
      }
      
    }else{
      return true;
    }
  }

  enviando() {


    if (this.formulario.valid) {
      if(this.verificarTempo()){
        let dados = JSON.parse(JSON.stringify(this.formulario.value));
        if(this.localizacao){
          dados.cidade = this.localizacao.geoplugin_city;
          dados.estado = this.localizacao.geoplugin_region;
        }
        this.loader.start();
        this.dao.submeter(dados, 'email').then(res => {
          this.loader.stop();
          this.enviarToast('success', 'Sucesso', 'Sua mensagem foi enviada com sucesso!');
          this.carregarFormularios();
          this.salvarMomento();
        }).catch(er => {
          this.loader.stop();
          this.enviarToast('error', 'Falha', er);
        });
      }else{
        this.enviarToast('error', 'Falha', 'É necessário aguardar 10 minutos antes de enviar outra mensagem!');
      }
      
        
      


    } else {
      this.enviarToast('error', 'Falha', 'Preencha todos os campos do formulário!');
    }
    //this.loader.start();

  }

  IsEmail(email) {
    var exclude = "/[^@-.w]|^[_@.-]|[._-]{2}|[@.]{2}|(@)[^@]*1/";
    var check = "/@[w-]+./";
    var checkend = "/.[a-zA-Z]{2,3}$/";
    if (((email.search(exclude) != -1) || (email.search(check)) == -1) || (email.search(checkend) == -1)) { return false; }
    else { return true; }
  }

  ngAfterViewInit() {

  }
}
